export default "__VITE_ASSET__DCroNpbr__"